import { render, staticRenderFns } from "./UserV2.vue?vue&type=template&id=95b21f2c&"
import script from "./UserV2.vue?vue&type=script&lang=js&"
export * from "./UserV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports